const getNamedTag = (tags: string[], name: string) => {
  const tag = tags?.find((item: string) => item.includes(name))
  return tag?.includes(':') ? tag.split(':')[1] : null
}

export default getNamedTag
